module.exports = __webpack_public_path__ + "img/frame (58).422d1deb.jpg";